module.exports = __webpack_public_path__ + "dd5881acf9cbc0d94c68a217aa42a6c6.jpg";